import { useState } from "react"

export default function WhatsAppButton() {
  const [hovered, setHovered] = useState(false)
  const phoneNumber = "5527998797619"
  const message = encodeURIComponent("Olá! Gostaria de saber mais sobre o EW Pass.")
  const whatsappUrl = `https://wa.me/${phoneNumber}?text=${message}`

  return (
    <a
      href={whatsappUrl}
      target="_blank"
      rel="noopener noreferrer"
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
      aria-label="Fale conosco no WhatsApp"
      className="fixed bottom-20 md:bottom-8 right-4 md:right-6 z-50 flex items-center gap-2 group"
    >
      {hovered && (
        <span className="hidden md:inline-block bg-white text-gray-800 text-sm font-semibold px-3 py-2 rounded-lg shadow-lg animate-fade-in whitespace-nowrap">
          Fale conosco
        </span>
      )}
      <div className="relative">
        <div className="absolute inset-0 bg-green-400 rounded-full animate-ping opacity-30" />
        <div
          className="relative w-14 h-14 bg-green-500 hover:bg-green-600 rounded-full flex items-center justify-center shadow-lg shadow-green-500/40 hover:shadow-green-600/50 transition-all duration-300 hover:scale-110"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 32 32"
            className="w-8 h-8 fill-white"
          >
            <path d="M16.004 0h-.008C7.174 0 0 7.176 0 16.004c0 3.5 1.129 6.744 3.047 9.379L1.054 31.25l6.1-1.953a15.9 15.9 0 0 0 8.85 2.676C24.826 31.973 32 24.797 32 16.004 32 7.176 24.826 0 16.004 0zm9.35 22.617c-.393 1.107-1.941 2.027-3.176 2.295-.844.18-1.945.324-5.656-1.215-4.75-1.969-7.805-6.797-8.04-7.113-.226-.316-1.898-2.527-1.898-4.82 0-2.293 1.2-3.422 1.625-3.89.394-.434.86-.543 1.148-.543.285 0 .57.003.82.015.263.012.617-.1.965.735.36.867 1.222 2.977 1.332 3.195.11.219.183.473.036.762-.148.29-.222.47-.437.723-.219.254-.46.566-.656.76-.219.218-.446.454-.192.89.254.434 1.13 1.867 2.426 3.024 1.668 1.488 3.074 1.95 3.508 2.168.434.219.688.183.941-.11.254-.29 1.09-1.27 1.38-1.707.29-.434.578-.36.976-.218.398.144 2.527 1.191 2.96 1.41.434.218.723.324.832.504.11.18.11 1.047-.283 2.156z" />
          </svg>
        </div>
      </div>
    </a>
  )
}
